"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DependencyController = void 0;
var base_request_1 = require("../../requests/base-request");
var DependencyController = /** @class */ (function () {
    function DependencyController() {
    }
    DependencyController.prototype.checkIfDependenciesExist = function () {
        if (!base_request_1.BaseRequest.dependencies) {
            base_request_1.BaseRequest.dependencies = {};
        }
    };
    DependencyController.prototype.setDependency = function (_a) {
        var name = _a.name, value = _a.value;
        try {
            this.checkIfDependenciesExist();
            base_request_1.BaseRequest.dependencies[name] = value;
        }
        catch (error) {
            console.error('setDependency gets an error', error);
        }
    };
    DependencyController.prototype.setDependencies = function (options) {
        try {
            this.checkIfDependenciesExist();
            options.forEach(function (_a) {
                var name = _a.name, value = _a.value;
                base_request_1.BaseRequest.dependencies[name] = value;
            });
        }
        catch (error) {
            console.error('setDependencies gets an error', error);
        }
    };
    DependencyController.prototype.getDependency = function (name) {
        try {
            this.checkIfDependenciesExist();
            return base_request_1.BaseRequest.dependencies[name];
        }
        catch (error) {
            console.error('getDependency gets an error', error);
        }
    };
    DependencyController.prototype.getDependencies = function () {
        try {
            this.checkIfDependenciesExist();
            return base_request_1.BaseRequest.dependencies;
        }
        catch (error) {
            console.error('getDependencies gets an error', error);
        }
    };
    return DependencyController;
}());
exports.DependencyController = DependencyController;
